import style from './StoneHorizontalCenters.module.css'
import { useTranslation } from 'react-i18next'
import ContactsPopup from '../../../Components/PopUp/ContactPopUp'
import React, { useState, useMemo } from 'react'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'
import Breadcrumbs from '../../../Components/Breadcrumbs/Breadcrumbs'

const StoneHorizontalCenters = () => {
  const { t } = useTranslation()

  // Get the title text from the translation
  const titleText = t('stoneHorizontalCenters.title')

  const [showPopup, setShowPopup] = useState(false)

  const handleOpenPopup = () => {
    setShowPopup(true)
  }

  const handleClosePopup = () => {
    setShowPopup(false)
  }

  const breadcrumbItems = useMemo(
    () => [
      { path: '/', label: t('breadcrumbs.home') },
      { path: '/engineering', label: t('breadcrumbs.engineering') },
      {
        path: '/engineering/glass-stone',
        label: t('breadcrumbs.page4'),
      },
    ],
    [t],
  )

  return (
    <div className={style.engineering} id="engineering">
      <div className={`${'customContainer'} ${style.engineering_wrap}`}>
        <Breadcrumbs items={breadcrumbItems} absolute={true} />
        <h2 className={style.title}>{titleText}</h2>
        <button onClick={handleOpenPopup} className={style.button}>
          {t('stoneHorizontalCenters.button')}
        </button>
        <div className={style.block_arrow}>
          <ScrollArrow />
        </div>
      </div>
      <ContactsPopup
        show={showPopup}
        onHide={handleClosePopup}
        title={titleText}
      />
    </div>
  )
}

export default StoneHorizontalCenters
